import { SkeletonBase } from "@unified-checkout/design-system";
import styles from "./section-loader.module.scss";


const DEFAULT_DIMENSIONS = [
  { width: "100%", height: "2.5rem" },
];

const DEFAULT_GAP = '1.25rem';


export const SectionLoader = ({
  gap = DEFAULT_GAP,
  dimensionsList = DEFAULT_DIMENSIONS
}: {
  dimensionsList?: {
    width?: string,
    height?: string,
    marginBottom?: string
  }[],
  gap?: string
}) => {
  return (
    <div
      className={styles["section-loader"]}
      style={{ gap }}
    >
      {
        dimensionsList.map(({ width, height, marginBottom }, i) => (
          <div
            key={`section-loader-skeleton-base-${i}`}
            className={styles["section-loader__skeleton-base"]}
            style={{ marginBottom }}
          >
            <SkeletonBase
              width={width}
              height={height}
            />
          </div>
        ))
      }
    </div>
  )
};